import {create} from 'zustand';

interface ViewOnceActionsState {
  /** Action names already recorded in the current view. */
  recorded: Record<string, true>;

  markRecorded: (name: string) => void;
  reset: () => void;
}

/**
 * Shares per-view deduplication between analytics destinations.
 * The app’s manual view lifecycle resets this store on navigation.
 */
export const useViewOnceActionsStore = create<ViewOnceActionsState>()(set => ({
  recorded: {},

  markRecorded: name =>
    set(state => ({recorded: {...state.recorded, [name]: true}})),
  reset: () => set({recorded: {}}),
}));

/**
 * Returns true the first time `name` is claimed in the current view and
 * false for every later call until the view resets.
 */
export function claimViewOnceAction(name: string): boolean {
  const store = useViewOnceActionsStore.getState();
  if (store.recorded[name]) {
    return false;
  }
  store.markRecorded(name);
  return true;
}

/** Starts a new view with an empty action cache. */
export function resetViewOnceActions(): void {
  useViewOnceActionsStore.getState().reset();
}
